var $ = jQuery;

$(document).on('ready', function(){
    var video = $('#video-player')[0]; 
    $(document).on('click', '.play-btn', function() {
        if (video.paused || video.ended) {
            video.play();
            $('.play-btn-text').text('pause');
        } else {
            video.pause();
            $('.play-btn-text').text('play');
        }
    })
})